import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { ViewsComponent } from './components/date/views.component'

import { SharedIconsModule } from '@alliance/shared/icons'
import { SharedPipesPrettyNumberModule } from '@alliance/shared/pipes/pretty-number'

@NgModule({
  imports: [CommonModule, SharedIconsModule, SharedPipesPrettyNumberModule],
  declarations: [ViewsComponent],
  exports: [ViewsComponent]
})
export class ClubsUiViewsModule {}
